var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import Text from "../text/Text";
import Button from "../button/Button";
import TextField from "./textfield/TextField";
import { CheckBox } from "./toggle";
import Box from "../box/Box";
import { isValidEmail } from "../utils";
import useRemoteDataState from "../hooks/useRemoteData";
var Form = function (_a) {
    var formMessage = _a.formMessage, isSubmitting = _a.isSubmitting, handleSubmit = _a.handleSubmit;
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = useState("1"), optin = _c[0], setOptin = _c[1];
    return (React.createElement(React.Fragment, null,
        formMessage ? (formMessage) : (React.createElement(Text, { as: "p", color: "grays.4", mb: 4, display: "block" }, "Sign up here and we will notify you the glorious moment this product arrives.")),
        React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
                handleSubmit({ email: email, optin: optin });
            } },
            React.createElement(TextField, { type: "email", name: "email", placeholder: "Email", onChange: function (e) { return setEmail(e.target.value); }, value: email }),
            React.createElement(CheckBox, { label: "Also sign up for the newsletter for killer deals!", checked: optin === "1", value: 1, onChange: function (_a) {
                    var checked = _a.target.checked;
                    setOptin(checked ? "1" : "0");
                } }),
            React.createElement(Button, { type: "submit", width: 1, mt: 4, disabled: isSubmitting }, isSubmitting ? "Sending..." : "Let me know"))));
};
function StockNotificationForm(_a) {
    var pid = _a.pid, onSignup = _a.onSignup, formMessage = _a.formMessage, rest = __rest(_a, ["pid", "onSignup", "formMessage"]);
    var _b = useRemoteDataState(), remoteData = _b[0], dispatch = _b[1];
    var handleSubmit = function (values) {
        if (isValidEmail(values.email)) {
            dispatch({ type: "LOADING" });
            var formData_1 = new FormData();
            formData_1.append("pid", pid.toString());
            formData_1.append("email", values.email);
            formData_1.append("optin", values.optin);
            fetch("/onnit/req/stock-notification.php", {
                method: "POST",
                body: formData_1,
            })
                .then(function (resp) {
                if (!resp.ok) {
                    return resp.json().then(function (text) {
                        throw new Error(text.message.toString());
                    });
                }
                return resp.json();
            })
                .then(function (resp) {
                dispatch({
                    type: "SUCCESS",
                    payload: resp.message,
                });
                if (values.optin === "1" && window.ONNIT && window.ONNIT.hubspot) {
                    window.ONNIT.hubspot.emailListSignup(values.email, ["list_onnit_newsletter"], "onnit:stock-notify");
                }
                onSignup === null || onSignup === void 0 ? void 0 : onSignup(formData_1);
            })
                .catch(function (e) {
                dispatch({
                    type: "FAILURE",
                    payload: e,
                });
                console.debug(e);
                return Promise.reject();
            })
                .catch(function onReject() {
            });
        }
    };
    return (React.createElement(Box, __assign({}, rest),
        React.createElement(Text, { as: "h2", fontSize: 5, fontWeight: "bold", mb: 3 }, "Out of stock"),
        remoteData.type === "SUCCESS" ? (React.createElement(Text, { role: "alert" }, remoteData.data)) : (React.createElement(React.Fragment, null,
            React.createElement(Form, { formMessage: formMessage, handleSubmit: handleSubmit, isSubmitting: remoteData.eq("LOADING") }),
            remoteData.type === "FAILURE" && (React.createElement(Text, { color: "accent.0.4", mt: 2, p: 2, role: "alert" }, remoteData.errors.message))))));
}
export default StockNotificationForm;
//# sourceMappingURL=StockNotificationForm.js.map